import { Component, Directive, Input, Output, EventEmitter, ChangeDetectionStrategy, ViewChild,
         ElementRef, Renderer2, TemplateRef, ViewContainerRef, ChangeDetectorRef, forwardRef } from '@angular/core';
import { TemplatePortalDirective } from '@angular/material';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

const /** @type {?} */ noop: any = () => {
  // empty method
};

export const /** @type {?} */ FILE_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => TdFileInputComponent),
  multi: true,
};
export class TdFileInputLabelDirective extends TemplatePortalDirective {
/**
 * @param {?} templateRef
 * @param {?} viewContainerRef
 */
constructor(templateRef: TemplateRef<any>, viewContainerRef: ViewContainerRef) {
    super(templateRef, viewContainerRef);
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[td-file-input-label]ng-template',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: TemplateRef, },
{type: ViewContainerRef, },
];
}

function TdFileInputLabelDirective_tsickle_Closure_declarations() {
/** @type {?} */
TdFileInputLabelDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdFileInputLabelDirective.ctorParameters;
}

export class TdFileInputComponent implements ControlValueAccessor {
/**
 * Implemented as part of ControlValueAccessor.
 */
private _value: FileList | File = undefined;
/**
 * @return {?}
 */
get value(): FileList | File { return this._value; }
/**
 * @param {?} v
 * @return {?}
 */
set value(v: FileList | File) {
    if (v !== this._value) {
      this._value = v;
      this.onChange(v);
    }
  }
private _multiple: boolean = false;
private _disabled: boolean = false;
/**
 * The native `<input type="file"> element
 */
_inputElement: ElementRef;
/**
 * @return {?}
 */
get inputElement(): HTMLInputElement {
    return this._inputElement.nativeElement;
  }
/**
 * color?: string
 * Sets button color. Uses same color palette accepted as [mdButton].
 */
color: string;
/**
 * multiple?: boolean
 * Sets if multiple files can be dropped/selected at once in [TdFileInputComponent].
 * @param {?} multiple
 * @return {?}
 */
set multiple(multiple: string | boolean) {
    this._multiple = multiple !== '' ? (multiple === 'true' || multiple === true) : true;
  }
/**
 * @return {?}
 */
get multiple(): string | boolean {
    return this._multiple;
  }
/**
 * accept?: string
 * Sets files accepted when opening the file browser dialog.
 * Same as 'accept' attribute in <input/> element.
 */
accept: string;
/**
 * disabled?: boolean
 * Disables [TdFileInputComponent] and clears selected/dropped files.
 * @param {?} disabled
 * @return {?}
 */
set disabled(disabled: boolean) {
    if (disabled) {
      this.clear();
    }
    this._disabled = disabled;
  }
/**
 * @return {?}
 */
get disabled(): boolean {
    return this._disabled;
  }
/**
 * select?: function
 * Event emitted a file is selected
 * Emits a [File | FileList] object.
 */
onSelect: EventEmitter<File | FileList> = new EventEmitter<File | FileList>();
/**
 * @param {?} _renderer
 * @param {?} _changeDetectorRef
 */
constructor(private _renderer: Renderer2,
private _changeDetectorRef: ChangeDetectorRef) {

  }
/**
 * Method executed when a file is selected.
 * @param {?} files
 * @return {?}
 */
handleSelect(files: File | FileList): void {
    this.writeValue(files);
    this.onSelect.emit(files);
  }
/**
 * Used to clear the selected files from the [TdFileInputComponent].
 * @return {?}
 */
clear(): void {
    this.writeValue(undefined);
    this._renderer.setProperty(this.inputElement, 'value', '');
  }
/**
 * Implemented as part of ControlValueAccessor.
 * @param {?} value
 * @return {?}
 */
writeValue(value: any): void {
    this.value = value;
    this._changeDetectorRef.markForCheck();
  }
/**
 * @param {?} fn
 * @return {?}
 */
registerOnChange(fn: any): void {
    this.onChange = fn;
  }
/**
 * @param {?} fn
 * @return {?}
 */
registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onChange = (_: any) => noop;
  onTouched = () => noop;

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  moduleId: module.id,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ FILE_INPUT_CONTROL_VALUE_ACCESSOR ],
  selector: 'td-file-input',
  styleUrls: ['./file-input.component.css'],
  templateUrl: './file-input.component.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer2, },
{type: ChangeDetectorRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'_inputElement': [{ type: ViewChild, args: ['fileInput', ] },],
'color': [{ type: Input, args: ['color', ] },],
'multiple': [{ type: Input, args: ['multiple', ] },],
'accept': [{ type: Input, args: ['accept', ] },],
'disabled': [{ type: Input, args: ['disabled', ] },],
'onSelect': [{ type: Output, args: ['select', ] },],
};
}

function TdFileInputComponent_tsickle_Closure_declarations() {
/** @type {?} */
TdFileInputComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdFileInputComponent.ctorParameters;
/** @type {?} */
TdFileInputComponent.propDecorators;
/**
 * Implemented as part of ControlValueAccessor.
 * @type {?}
 */
TdFileInputComponent.prototype._value;
/** @type {?} */
TdFileInputComponent.prototype._multiple;
/** @type {?} */
TdFileInputComponent.prototype._disabled;
/**
 * The native `<input type="file"> element
 * @type {?}
 */
TdFileInputComponent.prototype._inputElement;
/**
 * color?: string
 * Sets button color. Uses same color palette accepted as [mdButton].
 * @type {?}
 */
TdFileInputComponent.prototype.color;
/**
 * accept?: string
 * Sets files accepted when opening the file browser dialog.
 * Same as 'accept' attribute in <input/> element.
 * @type {?}
 */
TdFileInputComponent.prototype.accept;
/**
 * select?: function
 * Event emitted a file is selected
 * Emits a [File | FileList] object.
 * @type {?}
 */
TdFileInputComponent.prototype.onSelect;
/** @type {?} */
TdFileInputComponent.prototype.onChange;
/** @type {?} */
TdFileInputComponent.prototype.onTouched;
/** @type {?} */
TdFileInputComponent.prototype._renderer;
/** @type {?} */
TdFileInputComponent.prototype._changeDetectorRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
